import api from "./api"


// =========================================================
// HELPERS
// =========================================================

const cleanParams = (
  params = {}
) =>
  Object.fromEntries(
    Object.entries(
      params
    ).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all" &&
        value !== "ALL"
    )
  )


// =========================================================
// FORM DATA
// =========================================================

export const getHrLeaveFormData =
  async () =>
    (
      await api.get(
        "/hr/leaves/form-data"
      )
    ).data


// =========================================================
// LIST
// =========================================================

export const getHrLeaveRequests =
  async (
    params = {}
  ) =>
    (
      await api.get(
        "/hr/leaves",
        {
          params:
            cleanParams(
              params
            ),
        }
      )
    ).data


// Compatibilité avec les anciennes pages

export const getLeaveRequests =
  getHrLeaveRequests


export const getHrLeaves =
  getHrLeaveRequests


export const getLeaves =
  getHrLeaveRequests


export const listLeaves =
  getHrLeaveRequests


// =========================================================
// DETAIL
// =========================================================

export const getHrLeaveRequestById =
  async (
    id
  ) =>
    (
      await api.get(
        `/hr/leaves/${id}`
      )
    ).data


// =========================================================
// CREATE
// =========================================================

export const createHrLeaveRequest =
  async (
    payload
  ) =>
    (
      await api.post(
        "/hr/leaves",
        payload
      )
    ).data


export const createLeaveRequest =
  createHrLeaveRequest


// =========================================================
// UPDATE
// =========================================================

export const updateHrLeaveRequest =
  async (
    id,
    payload
  ) =>
    (
      await api.put(
        `/hr/leaves/${id}`,
        payload
      )
    ).data


export const updateLeaveRequest =
  updateHrLeaveRequest


// =========================================================
// APPROVE
// =========================================================

export const approveHrLeaveRequest =
  async (
    id,
    payload = {}
  ) =>
    (
      await api.post(
        `/hr/leaves/${id}/approve`,
        payload
      )
    ).data


export const approveLeaveRequest =
  approveHrLeaveRequest


// =========================================================
// REJECT
// =========================================================

export const rejectHrLeaveRequest =
  async (
    id,
    payload = {}
  ) =>
    (
      await api.post(
        `/hr/leaves/${id}/reject`,
        payload
      )
    ).data


export const rejectLeaveRequest =
  rejectHrLeaveRequest


// =========================================================
// CANCEL
// =========================================================

export const cancelHrLeaveRequest =
  async (
    id,
    payload = {}
  ) =>
    (
      await api.post(
        `/hr/leaves/${id}/cancel`,
        payload
      )
    ).data


export const cancelLeaveRequest =
  cancelHrLeaveRequest